export enum Lang {
	en = "en",
	de = "de",
}
